import { InjectionToken } from "@angular/core";

export const HTTP_OPTIONS = new InjectionToken<HttpOptions>("HTTP_OPTIONS");

export interface HttpOptions {
	contentType?: string;
}
